









































































































































































































































































































































































































































































































































































interface Form {
  select_label: string | undefined;
  select_value: string | undefined;
  level: string | undefined;
  salesman: string | undefined;
  referrer: any;
  status: string | undefined;
  time: Moment[];
}
interface AddModal {
  name: string | undefined;
  mobile: string | undefined;
  level: string | undefined;
  salesman: string | undefined;
  referrer: any;
}
interface EditModal {
  clerk_id: string | undefined;
  name: string | undefined;
  account_status: string | undefined;
  level: string | undefined;
  salesman: string | undefined;
  referrer: any;
}
interface WareModel {
  type: number[];
  name: string;
  stock_pattern: string;
  ware_id: string;
  add_stock: string;
}
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { date } from '@/util/adapter';
import moment, { Moment } from 'moment';
import { State, Mutation, Action } from 'vuex-class';
import { WARE_TYPE_LIST, STOCK_PATTERN } from '../ware/constant';
const uuidv4 = require('uuid/v4');
const { VUE_APP_API } = process.env;
const API = {
  query: `${VUE_APP_API}/qy/user/clerk/list-detail`,
  add: `${VUE_APP_API}/qy/user/clerk/create`,
  accountOn: `${VUE_APP_API}/qy/user/clerk/account-on`,
  accountOff: `${VUE_APP_API}/qy/user/clerk/account-off`,
  merchant_config: `${VUE_APP_API}/qy/merchant/account/config`,
  edit_clerk: `${VUE_APP_API}/qy/user/clerk/edit`,
  edit_account_status: `${VUE_APP_API}/qy/user/clerk/edit-account-status`,
  clerk_list: `${VUE_APP_API}/qy/user/clerk/search`,
  ware_list: `${VUE_APP_API}/qy/ware/clerk-ware-config-list`,
  init_first_stock: `${VUE_APP_API}/qy/user/clerk/init-first-stock`,
};

const UPLOAD_DIR = {
  setting: 'setting',
};

const VALIDATE = {
  isName: false,
  isMobile: false,
  isLevel: false,
  isSalesman: false,
};
const STATUS_LIST = [
  {
    _key: uuidv4(),
    label: '正常',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '停用',
    value: '2',
  },
];

const LABEL_LIST = [
  {
    _key: uuidv4(),
    label: '姓名',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '手机号',
    value: '2',
  },
  {
    _key: uuidv4(),
    label: 'ID',
    value: '3',
  },
];

const MARK_STATUS_LIST = {
  1: '上架中',
  2: '已售罄',
  3: '仓库中',
};

@Component
export default class SaleList extends Vue {
  is_loading: boolean = false;
  UPLOAD_DIR: any = UPLOAD_DIR;
  form: Form = {
    select_label: '1',
    select_value: undefined,
    level: '0',
    salesman: undefined,
    referrer: undefined,
    status: '0',
    time: [],
  };
  label_list: any = LABEL_LIST;
  level_list: any = [];
  status_list: any = STATUS_LIST;
  ware_type_list: any = WARE_TYPE_LIST;
  stock_pattern_list: any = STOCK_PATTERN;
  mark_status_list: any = MARK_STATUS_LIST;
  stock_status_list: any = {};
  table_data: any = {};
  page: number = 1;
  add_modal: AddModal = {
    name: undefined,
    mobile: undefined,
    level: undefined,
    salesman: undefined,
    referrer: undefined,
  };
  edit_modal: EditModal = {
    clerk_id: undefined,
    name: undefined,
    account_status: undefined,
    level: undefined,
    salesman: undefined,
    referrer: undefined,
  };
  is_show_add_modal: boolean = false;
  is_show_edit_modal: boolean = false;
  is_loading_edit_modal: boolean = false;
  is_show_edit_account_modal: boolean = false;
  is_show_stock_ware_modal: boolean = false;
  modal_item: any = {};
  edit_modal_title: string = '';
  model_layout: any = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  validate: any = VALIDATE;
  is_button_loading: boolean = true;
  is_show_log: boolean = false;
  log_item: any = {};
  ware_modal: WareModel = {
    type: [0],
    name: '',
    stock_pattern: '0',
    ware_id: '',
    add_stock: '',
  };
  staff_first_text: any = '';
  staff_second_text: any = '';
  merchant_config: any = {};
  clerk_list: any = [];
  clerk_list_all: any = [];
  is_close_loading: boolean = false;
  timeout: any = null;
  fetching: boolean = false;
  ware_page: number = 1;
  ware_data: any = {};
  table_loading: boolean = false;

  query(page: number = 1) {
    this.is_loading = !this.is_close_loading; // 修改账号状态，因为后台数据返回较慢，需要操作完成后5s后重新请求query接口，此时不出现loading
    this.is_close_loading = false;
    this.page = page;
    const form = this.form;
    const send_data: any = {};
    const startTime: Moment = form.time[0];
    const endTime: Moment = form.time[1];
    send_data.page = page;
    if (form.select_label === '1') {
      send_data.name = form.select_value;
    } else if (form.select_label === '2') {
      send_data.mobile = form.select_value;
    } else if (form.select_label === '3') {
      send_data.id = form.select_value;
    }
    send_data.level = form.level === '0' ? '' : form.level;
    send_data.parent_id = form.salesman;
    send_data.referer_id = form.referrer;
    send_data.start_time = startTime ? date(startTime) : undefined;
    send_data.end_time = endTime ? date(endTime) : undefined;
    send_data.account_status = form.status === '0' ? '' : form.status;
    return this.$axios
      .get(API.query, { params: send_data })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        const data = remote.data || {};
        this.table_data = data;
      })
      .finally(() => {
        this.is_loading = false;
      });
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  handChangeWarePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.submitWare(next_page);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }

  accountStatus(item: any, type: any) {
    const url = type === 'on' ? API.accountOn : API.accountOff;
    this.$axios
      .post(url, { code: item.code })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error) {
          this.$message.error(remote.message);
          return;
        }
        this.$message.success('修改成功');
      })
      .finally(() => {
        this.query(this.page);
      });
  }

  focusModel(type: string, key: string) {
    this.validate[type] = false;
  }

  validateModel(option: string, key: string, type: any) {
    if (type === 'add') {
      this.validate[option] = !(this.add_modal as any)[key];
    } else {
      this.validate[option] = !(this.edit_modal as any)[key];
    }
  }

  submitAdd() {
    if (!this.add_modal.name) {
      this.validate.isName = true;
      return;
    }
    if (!this.add_modal.name.trim()) {
      this.validate.isName = true;
      return;
    }
    if (
      !this.add_modal.mobile ||
      !/^1[0-9]{10}$/.test(String(this.add_modal.mobile))
    ) {
      this.validate.isMobile = true;
      return;
    }
    if (!this.add_modal.level) {
      this.validate.isLevel = true;
      return;
    }
    if (this.add_modal.level === '2' && !this.add_modal.salesman) {
      this.validate.isSalesman = true;
      return;
    }
    if (this.is_button_loading) {
      this.is_button_loading = false;
      const send_data: any = {};
      send_data.name = this.add_modal.name;
      send_data.mobile = this.add_modal.mobile;
      send_data.level = this.add_modal.level;
      if (send_data.level === '2') {
        send_data.parent_id = this.add_modal.salesman;
      }
      send_data.referer_id = this.add_modal.referrer;
      this.$axios
        .post(API.add, send_data)
        .then((res: AxiosResponse) => {
          const remote = res.data;
          if (remote.error !== 0) {
            this.$message.error(remote.message);
            return;
          }
          this.is_show_add_modal = false;
          this.$message.success('新增成功');
          this.add_modal.name = undefined;
          this.add_modal.mobile = undefined;
          this.add_modal.level = undefined;
          this.add_modal.salesman = undefined; // 新增分销员以后，刷新全局变量数据
          this.add_modal.referrer = undefined;
        })
        .finally(() => {
          this.is_button_loading = true;
          this.query();
        });
    }
  }

  submitEdit() {
    if (!this.edit_modal.name) {
      this.validate.isName = true;
      return;
    }
    if (!this.edit_modal.name.trim()) {
      this.validate.isName = true;
      return;
    }
    if (this.edit_modal.level === '2' && !this.edit_modal.salesman) {
      this.validate.isSalesman = true;
      return;
    }
    const _this = this;
    if (String(this.modal_item.level) !== this.edit_modal.level) {
      this.$confirm({
        title: '是否确认修改等级',
        centered: true,
        onOk() {
          _this.submitEditMessage();
        },
        onCancel() {
          return;
        },
        class: 'test',
      });
      return;
    }
    this.submitEditMessage();
  }

  submitEditMessage() {
    if (this.is_button_loading) {
      this.is_button_loading = false;
      const send_data: any = {};
      send_data.clerk_id = this.edit_modal.clerk_id;
      send_data.name = this.edit_modal.name;
      send_data.level = this.edit_modal.level;
      if (send_data.level === '2') {
        send_data.parent_id = this.edit_modal.salesman;
      }
      send_data.referer_id = this.edit_modal.referrer;
      this.$axios
        .post(API.edit_clerk, send_data)
        .then((res: AxiosResponse) => {
          const remote = res.data;
          if (remote.error !== 0) {
            this.$message.error(remote.message);
            return;
          }
          this.is_show_edit_modal = false;
          this.$message.success('编辑成功');
          this.edit_modal.name = '';
          this.edit_modal.level = '';
          this.edit_modal.salesman = '';
          this.edit_modal.referrer = undefined;
          setTimeout(() => {
            // 修改账号状态，因为后台数据返回较慢，需要操作完成后5s后重新请求query接口，此时不出现loading
            this.is_close_loading = true;
            this.query(this.page);
          }, 5000);
        })
        .finally(() => {
          this.is_button_loading = true;
          this.query(this.page);
        });
    }
  }

  submitEditAccount() {
    if (
      String(this.modal_item.account_status) === this.edit_modal.account_status
    ) {
      this.$message.info('请修改后再提交确认');
      return;
    }
    const _this = this;
    this.$confirm({
      title:
        _this.edit_modal.account_status === '2'
          ? '是否确认停用，停用后身份将恢复普通会员'
          : '是否确认修改',
      centered: true,
      onOk() {
        if (_this.is_button_loading) {
          _this.is_button_loading = false;
          const send_data: any = {};
          send_data.clerk_id = _this.edit_modal.clerk_id;
          send_data.account_status = _this.edit_modal.account_status;
          _this.$axios
            .post(API.edit_account_status, send_data)
            .then((res: AxiosResponse) => {
              const remote = res.data;
              if (remote.error !== 0) {
                _this.$message.error(remote.message);
                return;
              }
              _this.is_show_edit_account_modal = false;
              _this.$message.success('编辑成功');
              _this.edit_modal.account_status = '';
              setTimeout(() => {
                // 修改账号状态，因为后台数据返回较慢，需要操作完成后5s后重新请求query接口，此时不出现loading
                _this.is_close_loading = true;
                _this.query(_this.page);
              }, 5000);
            })
            .finally(() => {
              _this.is_button_loading = true;
              _this.query(_this.page);
            });
        }
      },
      onCancel() {
        return;
      },
      class: 'test',
    });
  }

  cancelStatus() {
    for (const key in this.validate) {
      if (this.validate[key]) {
        this.validate[key] = false;
      }
    }
  }

  getPopupContainer() {
    return document.getElementById('sale-list');
  }

  showLog(item: any) {
    this.is_show_log = true;
    this.log_item = item.log;
  }

  getCheckboxProps(record: any) {
    return {
      props: {
        disabled: record.current_stock > 0,
        name: record.name,
      },
    };
  }

  wareTag(item: any) {
    const text_first: string = item.type === 1 ? '实物' : '虚拟';
    const text_second: string =
      item.type === 1
        ? ''
        : item.type === 2 && item.type_secondary === 1
        ? '/兑换码'
        : '/无';
    return `${text_first}${text_second}`;
  }

  submit() {
    this.query();
  }

  clearForm() {
    const form = this.form;
    form.select_label = '1';
    form.select_value = undefined;
    form.level = '0';
    form.salesman = undefined;
    form.referrer = undefined;
    form.status = '0';
    form.time = [];
  }

  searchSaler(item: any) {
    this.$axios
      .get(`${API.clerk_list}?level=1&fuzzy_name=${item.name}`)
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        this.clerk_list = remote.data;
        this.clearForm();
        this.form.salesman = this.clerk_list[0].id;
        this.query();
      });
  }

  async getMerchantConfig() {
    const _data =
      ((await this.$axios.get(API.merchant_config)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.merchant_config = _data.data;
    this.staff_first_text = this.merchant_config.role_name || '一级';
    this.staff_second_text = this.merchant_config.role_name_two || '二级';
  }

  searchSalesman(value: any) {
    if (!value) {
      this.clerk_list = [];
      return;
    }
    this.fetching = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getClerkList(value);
    }, 1000 * Math.random());
  }

  getClerkList(name: any) {
    return this.$axios
      .get(`${API.clerk_list}?level=1&fuzzy_name=${name}`)
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        this.clerk_list = remote.data;
        if (this.clerk_list.length === 0) {
          this.fetching = false;
        }
      });
  }

  searchReferrer(value: any) {
    if (!value) {
      this.clerk_list_all = [];
      return;
    }
    this.fetching = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getClerkListAll(value);
    }, 1000 * Math.random());
  }

  getClerkListAll(name: any) {
    return this.$axios
      .get(`${API.clerk_list}?fuzzy_name=${name}`)
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        this.clerk_list_all = remote.data;
        if (this.clerk_list_all.length === 0) {
          this.fetching = false;
        }
      });
  }

  async showEditMessageModal(item: any) {
    this.is_loading_edit_modal = true;
    this.modal_item = item;
    this.edit_modal_title = `${item.name} 编辑`;
    this.is_show_edit_modal = true;
    if (item.level === 2) {
      const clerk_list_res =
        (
          (await this.$axios.get(
            `${API.clerk_list}?level=1&fuzzy_name=${item.parent_name}`,
          )) || {}
        ).data || {};
      if (clerk_list_res.error) {
        this.$message.error(clerk_list_res.message);
        return;
      }
      this.clerk_list = clerk_list_res.data;
    }
    if (item.referer_id) {
      const clerk_list_all_res =
        (
          (await this.$axios.get(
            `${API.clerk_list}?fuzzy_name=${item.referer_name}`,
          )) || {}
        ).data || {};
      if (clerk_list_all_res.error) {
        this.$message.error(clerk_list_all_res.message);
        return;
      }
      this.clerk_list_all = clerk_list_all_res.data;
    }
    this.edit_modal = {
      clerk_id: item.id,
      name: item.name,
      account_status: String(item.account_status),
      level: String(item.level),
      salesman: this.clerk_list.length > 0 ? this.clerk_list[0].id : undefined,
      referrer: item.referer_id ? Number(item.referer_id) : undefined,
    };
    this.is_loading_edit_modal = false;
  }

  showEditAccountModal(item: any) {
    this.modal_item = item;
    this.is_show_edit_account_modal = true;
    this.edit_modal = {
      clerk_id: item.id,
      name: undefined,
      account_status: String(item.account_status),
      level: undefined,
      salesman: undefined,
      referrer: undefined,
    };
  }

  searchWare() {
    this.submitWare(this.ware_page);
  }

  async submitWare(page: number = 1) {
    this.table_loading = true;
    this.ware_page = page;
    const ware_modal = this.ware_modal;
    const send_data: any = {
      page: this.ware_page,
      type: ware_modal.type[0],
      name: ware_modal.name,
      stock_pattern:
        ware_modal.stock_pattern === '0' ? [1, 2] : [ware_modal.stock_pattern],
    };
    if (ware_modal.type[1]) {
      send_data.type_secondary = ware_modal.type[1] ? ware_modal.type[1] : '0';
    }
    const res = await this.$axios.get(API.ware_list, {
      params: send_data,
    });
    const remote = res.data;
    if (remote.error) {
      this.$message.error(remote.message);
      this.table_loading = false;
      return;
    }
    this.ware_data = remote.data;
    this.table_loading = false;
  }

  async showEditStockModal() {
    this.is_show_stock_ware_modal = true;
    await this.submitWare();
  }

  onSelectWare(item: any) {
    this.ware_modal.ware_id = item.ware_id;
  }

  async submitEditStock() {
    if (!this.ware_modal.ware_id) {
      this.$message.error('请选择需要批量配置的商品');
      return;
    }
    if (this.ware_modal.add_stock === '0') {
      this.$message.error('输入的库存量必须大于零');
      return;
    }
    if (!this.ware_modal.add_stock) {
      this.$message.error('请输入每位一级增加的库存值');
      return;
    }
    const send_data = {
      ware_id: this.ware_modal.ware_id,
      stock: this.ware_modal.add_stock,
    };
    const res = await this.$axios.get(API.init_first_stock, {
      params: send_data,
    });
    const remote = res.data;
    if (remote.error) {
      this.$message.error(remote.message);
      return;
    }
    this.$message.success('配置成功');
    this.is_show_stock_ware_modal = false;
    this.ware_modal.ware_id = '';
    this.ware_modal.add_stock = '';
    await this.query(this.page);
  }

  async created() {
    await this.query(this.page);
    await this.getMerchantConfig();
    this.stock_pattern_list.forEach((item: any) => {
      this.stock_status_list[item.value] = item.label;
    });
    this.level_list = [
      {
        _key: uuidv4(),
        label: this.staff_first_text,
        value: '1',
      },
      {
        _key: uuidv4(),
        label: this.staff_second_text,
        value: '2',
      },
    ];
  }
}
